module.exports = __webpack_public_path__ + "img/Gruppenbild Song Contest 2022.e9739d8b.jpg";